import FootballState from "../../../../state/football-state";
import Rule from "../../../../../common/rule";

export default class KickOffOutOfBounds extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const nextFragment = play.getNextFragment(fragment);
        return (
            nextFragment.associatedState === FootballState.OutOfBounds &&
            !play.historyContains(FootballState.TouchBack)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.switchPossession();
    }
}
